var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 600 600"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Icons_Selected_10_Transfer"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 600
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons_Selected_10_Transfer",
    clipPath: "url(#clip-Icons_Selected_10_Transfer)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons_Selected_10_Transfer-2",
    "data-name": "Icons_Selected_10_Transfer",
    transform: "translate(-6.443 4.856)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shadow_Layer",
    transform: "translate(81.146 53.835)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 262.649,
    cy: 262.649,
    r: 262.649,
    fill: "#eaeaea"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M269.418,31.9,54.4,229.907l17.011,121.8L173.817,277.2,286.429,45.169Z",
    transform: "translate(115.202 49.833)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(6.443 11.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(71.977 12.647)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M390.275,36.4c-.34-5.1-1.361-10.207-4.083-14.629s-7.825-7.485-12.928-6.8c-2.722.34-4.763,1.7-7.145,3.062C327.675,40.483,292.292,66.68,255.889,92.2c-43.208,30.279-86.756,60.219-129.963,90.5-19.052,13.269-38.785,25.176-57.157,39.125-9.866,7.485-46.61,30.96-40.486,46.61,2.041,5.1,6.8,8.505,11.227,11.567,7.825,5.1,15.65,10.207,23.815,14.629,13.269,6.8,47.29,13.949,44.909,32.321-3.062,25.516-7.145,51.033-8.505,76.889-.68,14.289-1.7,41.507,12.588,49.672,13.949,7.825,30.279-4.423,41.166-16.331a801.013,801.013,0,0,0,60.9-74.848c19.392,10.207,39.125,17.691,59.2,26.2,12.928,5.443,35.383,21.774,48.991,7.485,9.186-9.866,9.186-39.125,11.567-52.394,10.207-53.414,20.413-106.488,30.62-159.9,4.423-23.475,9.186-46.95,13.609-70.425C383.471,87.093,392.657,63.958,390.275,36.4ZM208.939,292.585c-7.145,9.526-27.217,40.826-36.4,53.414-3.062,4.423-23.475,27.9-23.135,28.578a622.512,622.512,0,0,0-2.382-75.529c-.34-3.4-.68-6.8,1.021-9.526a11.728,11.728,0,0,1,4.083-4.083c14.629-11.908,12.588-11.908,25.516-25.516,27.217-29.259,97.983-105.128,101.385-108.87,5.784-6.124,41.507-44.569,58.858-51.373-9.186,23.815-25.176,44.569-39.806,64.982-14.289,20.073-26.877,41.507-41.507,61.58C240.92,248.357,224.929,270.471,208.939,292.585Z",
    transform: "translate(-27.599 -14.872)",
    fill: "#99c2fd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M276.091,551.235A269.982,269.982,0,0,1,6.638,289.947C3.916,217.821,29.773,149.1,79.1,96.363A270.419,270.419,0,0,1,357.063,23.556a8.367,8.367,0,0,1,5.443,10.887,8.367,8.367,0,0,1-10.887,5.443,260.043,260.043,0,0,0-84.034-11.567C200.222,30.36,137.622,58.939,91.352,108.27c-45.929,48.991-70.085,113.293-68.044,181S53.928,419.23,103.26,465.5a251.663,251.663,0,0,0,181,68.384c67.363-2.041,129.963-30.62,176.233-79.951a252.565,252.565,0,0,0-1.7-347.7,8.664,8.664,0,0,1,12.588-11.908,270.265,270.265,0,0,1,2.041,371.518,266.709,266.709,0,0,1-188.141,85.055C281.874,550.895,278.812,551.235,276.091,551.235Z",
    transform: "translate(-6.443 -11.155)",
    fill: "#4c4c4c"
  })))))));
};
export default __webpack_public_path__ + "static/media/Icons_Selected_10_Transfer.67c56792.svg";
export { SvgComponent as ReactComponent };